import service from '@/utils/request.js'
export function selectPolicyAll(data) {
  return service.request({
    method: 'get',
    url: '/teacher/business/afficheinfo/list',
    params: data
  });
}
export function NoticeAll(data) {
  return service.request({
    method: 'get',
    url: '/teacher/business/afficheinfo/afficheinfoList',
    params: data
  });
}
export function standardAll(data) {
  return service.request({
    method: 'get',
    url: '/teacher/business/afficheinfo/list',
    params: data
  });
}
export function selectMaterialCategory(params) {
  return service.request({
    method: 'get',
    url: '/sf/business/dicttype/list',
    params
  });
}

/**
 * 
 * 获取专业大类
 */

export function bigMajor(data) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/auditstoragepress/bigMajor',
    params:data
  });
}
export function selectPress(data) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/auditstoragepress/pressAllList',
    params: data
  });
}
export function selectTeachingMaterial(params) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/auditstoragepress/booksAllList',
    params
  });
}

// 教材库--出版社列表
export function selectProvincePress(params) {
  return service.request({
    method: 'get',
    url: '/teacher/controller/auditstoragepress/pressVoList',
    params
  });
}








